import styled from "styled-components";
import Tooltip from "./Tooltip";

const StyledCircleActionButton = styled.button<{ $active?: boolean }>`
  background-color: ${({ $active, theme }): string =>
    $active ? theme.colors.yellow : theme.colors.darkGray};
  border: 1px solid ${({ theme }): string => theme.colors.yellow};
  color: ${({ theme }): string => theme.colors.black};
  font-size: 1rem;
  font-weight: bold;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  display: flex;
`;

type CircleActionButtonProps = {
  styles?: React.CSSProperties;
  $tooltipContent?: string;
  $active?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
};
export const CircleActionButton: React.FC<CircleActionButtonProps> = ({
  styles,
  $tooltipContent,
  $active,
  onClick,
  children,
}) => {
  return (
    <Tooltip content={$tooltipContent} position="top">
      <StyledCircleActionButton
        style={styles}
        $active={$active}
        onClick={(e) => {
          e.stopPropagation();
          onClick?.();
        }}
      >
        {children}
      </StyledCircleActionButton>
    </Tooltip>
  );
};
